// Shared types and constants for Forecast Inputs feature.
// Import only from this file — never reach into sibling modules for types.

import type { ForecastOutlook } from "@workspace/api-client-react";

export type InputType = "accrual" | "commitment" | "planned_spend";
export type ScheduleType = "specific_month" | "even_monthly" | "monthly_amount" | "manual_monthly";
export type DrawerView = "manage" | "add";
export type ManageTab = InputType;

export interface ForecastContext {
  companyId: number;
  fiscalYear: number;
  throughPeriod: number;
  departmentCode: string;
  runId: string | null;
  isAuthoritative: boolean;
  outlook: ForecastOutlook | null;
}

export interface ScheduleEntry {
  fiscalYear: number;
  period: number;
  amount: number;
  sourceReference: string;
}

export const TAB_LABELS: Record<InputType, string> = {
  accrual: "Accruals",
  commitment: "Commitments",
  planned_spend: "Planned Spend",
};

export const TYPE_HELP: Record<InputType, { title: string; help: string }> = {
  accrual: { title: "Add Accrual", help: "Already incurred, not yet posted." },
  commitment: { title: "Add Commitment", help: "Already obligated, future spend." },
  planned_spend: { title: "Add Planned Spend", help: "Expected future spend, not yet obligated." },
};
